import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../providers/withRouter";
import { BsSearch } from "react-icons/bs";
import {
  getConsultores,
  getServiciosFincas,
  listTecnicos,
  listCosultor,
} from "../../services";
import { UsuarioContext } from "../../providers/userContext";
import {
  ordenarNombreYApellido,
  ordenarProvinciasYMunicipios,
  orderArray,
} from "../../functions/ordenarListas";
import { ImCross } from "react-icons/im";
import { listAAFFs, getChildrenAaffs } from "../../services";
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import { CustomSwitch } from "../Buttons/Switch";

import Acordeon from "./acordeonFiltros";

import SearchProgresState from "./SearchProgresState";
import { useLocation } from "react-router-dom";
import { IoInformationCircleOutline } from "react-icons/io5";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { municipiosIniciales, cambiarFormatoNombre } from "../../functions/funciones";
import { useEquipos, useGrupos } from "../../hooks/index";

const FiltrosVentas = ({ onFilter, clearFilter, filtrosIniciales }) => {
  const { t } = useTranslation('common');
  const { rol } = useContext(UsuarioContext);

  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const anoActual = new Date().getFullYear();

  const [aaff, setAAFF] = useState([]);
  const [tecnicos, setTecnicos] = useState([]);
  const [consultores, setConsultores] = useState([]);
  const [oficinas, setOficinas] = useState([]);
  const user = useContext(UsuarioContext);
  const [listAnos, setListAnos] = useState([]);
  const location = useLocation();
  const [sinConsul, setSinConsul] = useState(false);
  const [estados, setEstado] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [grupoServicios, setGrupoServicios] = useState([]);
  const [listadoMunicipios, setListadoMunicipios] = useState([]);
  const { equipos, fetchEquipos } = useEquipos();
  const { fetchGrupos } = useGrupos();
  
  const isFetchingDataRef = useRef(false);

  const esSafari = () => {
    const ua = navigator.userAgent;
    return /iPad|iPhone|iPod/.test(ua);
  };

  const [typeVentaInicio, setTypeVentaInicio] = useState(esSafari() ? "date" : "text");
  const [typeVentaFin, setTypeVentaFin] = useState(esSafari() ? "date" : "text");
  const [typeCreacionInicio, setTypeCreacionInicio] = useState(esSafari() ? "date" : "text");
  const [typeCreacionFin, setTypeCreacionFin] = useState(esSafari() ? "date" : "text");
  const [typeVencimientoInicio, setTypeVencimientoInicio] = useState(esSafari() ? "date" : "text");
  const [typeVencimientoFin, setTypeVencimientoFin] = useState(esSafari() ? "date" : "text");

  const handleFocusVentaInicio = () => !esSafari() && setTypeVentaInicio("date");
  const handleBlurVentaInicio = () => {
    if (!esSafari() && !busqueda.fechaVentaInicio) setTypeVentaInicio("text");
  };
  const handleFocusVentaFin = () => !esSafari() && setTypeVentaFin("date");
  const handleBlurVentaFin = () => {
    if (!esSafari() && !busqueda.fechaVentaFin) setTypeVentaFin("text");
  };
  const handleFocusCreacionInicio = () => !esSafari() && setTypeCreacionInicio("date");
  const handleBlurCreacionInicio = () => {
    if (!esSafari() && !busqueda.fechaCreacionInicio) setTypeCreacionInicio("text");
  };
  const handleFocusCreacionFin = () => !esSafari() && setTypeCreacionFin("date");
  const handleBlurCreacionFin = () => {
    if (!esSafari() && !busqueda.fechaCreacionFin) setTypeCreacionFin("text");
  };
  const handleFocusVencimientoInicio = () => !esSafari() && setTypeVencimientoInicio("date");
  const handleBlurVencimientoInicio = () => {
    if (!esSafari() && !busqueda.showVencimientoInicio) setTypeVencimientoInicio("text");
  };
  const handleFocusVencimientoFin = () => !esSafari() && setTypeVencimientoFin("date");
  const handleBlurVencimientoFin = () => {
    if (!esSafari() && !busqueda.showVencimientoFin) setTypeVencimientoFin("text");
  };

  useEffect(() => {
    if (busqueda?.estadoCae) {
      busqueda.estadoCae = busqueda?.estadoCae
        ?.split(",")
        .map((item) => parseInt(item.trim(), 10))
        .filter((item) => !isNaN(item));
    } else {
      delete busqueda.estadoCae;
    }
    if (busqueda?.estadoLopd) {
      busqueda.estadoLopd = busqueda?.estadoLopd
        ?.split(",")
        .map((item) => parseInt(item.trim(), 10))
        .filter((item) => !isNaN(item));
    } else {
      delete busqueda.estadoLopd;
    }
    if (busqueda?.estadoCai) {
      busqueda.estadoCai = busqueda?.estadoCai
        ?.split(",")
        .map((item) => parseInt(item.trim(), 10))
        .filter((item) => !isNaN(item));
    } else {
      delete busqueda.estadoCai;
    }

    listadoAnos();
    if (user.rol === "AAFF" && !busqueda.ano) {
      setBusqueda((prevBusqueda) => ({
        ...prevBusqueda,
      }));
    }

  }, []);

  useEffect(() => {
    isFetchingDataRef.current = false;

    cargarUser();
    getDatas();
    if (localStorage.getItem("hasReloaded") === "true") {
      clearAllFilters();
      cargarUser();
      localStorage.setItem("hasReloaded", "false");
    }
    fetchEquipos();
  }, [location]);


  useEffect(() => {
    const handleCacheUpdated = (evt) => {
      const nuevosEstados = evt?.detail?.states;
      const nuevosGrupos = evt?.detail?.groups;
      if (Array.isArray(nuevosEstados) && nuevosEstados.length > 0) {
        setEstado(nuevosEstados);
      }
      if (Array.isArray(nuevosGrupos) && nuevosGrupos.length > 0) {
        setGrupoServicios(nuevosGrupos.filter((g) => g.nombre !== "KAE"));
      }
    };
    window.addEventListener("dataCache:updated", handleCacheUpdated);
    return () => window.removeEventListener("dataCache:updated", handleCacheUpdated);
  }, []);

  const cargarUser = () => {
    if (user.rol === "CONSUL" && sinConsul == false) {
      setBusqueda({
        ...busqueda,
        consul_id: user.id,
      });
    }
    localStorage.setItem("hasReloaded", "false");
  };

  const clearAllFilters = () => {
    setBusqueda(
      user.rol == "TECH" || user.rol == "TECH_COOR"
        ? { visitasRecientes: false }
        : {}
    );
    setOficinas([]);
    clearFilter();
    cargarUser();
  };

  const listadoAnos = () => {
    let Anos = [];
    for (let i = 2021; i <= anoActual; i++) {
      Anos.push(i);
    }
    setListAnos(Anos);
  }

  const getDatas = async () => {
    if (isFetchingDataRef.current) {
      return;
    }
    
    try {
      isFetchingDataRef.current = true;
      
      const estados = JSON.parse(localStorage.getItem("states")) || [];
      setEstado(estados);

      const grupos = JSON.parse(localStorage.getItem("groups")) || [];
      setGrupoServicios(grupos.filter((g) => g.nombre !== "KAE"));

      const serviciosFincas =
        user.rol === "AAFF" ||
          user.rol === "ADMIN" ||
          user.rol === "CONSUL" ||
          user.rol === "VENT" ||
          user.rol === "TECH" ||
          user.rol === "TECH_COOR" ||
          user.rol == "COMM"
          ? await getServiciosFincas()
          : [];

      const serviciosSinKae = serviciosFincas?.filter((item) => item.id !== 10) || [];

      if (user.rol === "AAFF" && serviciosSinKae.length > 0) {
        setServicios(
          serviciosSinKae.filter(
            (item) => item.id !== 6 && item.id !== 7
          )
        );
      } else {
        setServicios(serviciosSinKae);
      }
        
      const consul =
        user.rol === "CONSUL"
          ? await getConsultores({ filtros: { id: user.id } })
          : [];

      if (user.rol === "CONSUL" && consul.data?.length > 0) {
        setBusqueda({
          ...busqueda,
          consul_id: user.id,
        });

        setConsultores(ordenarNombreYApellido(consul.data));
      }

      if (user.rol === "AAFF" && user.parent === true) {
        const oficinasResponse = await getChildrenAaffs(user.id, {
          filtros: {},
          params: { page: 1, limit: 1000, order: 'ASC', orderBy: 'razonSocial' }
        });
        if (oficinasResponse?.data) {
          const oficinasPadre = {
            id: user.id,
            razonSocial: user.razonSocial || user.nombre || "Oficina Principal",
            nif: user.nif
          };
          setOficinas([oficinasPadre, ...oficinasResponse.data]);
        }
      }
    } catch (error) {
      console.error("Error en getDatas:", error);
    } finally {
      setTimeout(() => {
        isFetchingDataRef.current = false;
      }, 100);
    }
  };

  const handleAsynchronousChange = async (name, selectedValue) => {
    // Si se selecciona un AAFF, cargar sus oficinas (hijos)
    if (name === "aaff_id") {
      if (selectedValue?.id) {
        const filtrosOficina = {};
        if (user.rol === "TECH_COOR") {
          // Coordinador: oficinas asignadas a su equipo (subordinados)
          filtrosOficina.team_id = user.equipo;
        } else if (user.rol === "TECH") {
          filtrosOficina.tech_id = user.id;
        }
        const oficinasResponse = await getChildrenAaffs(selectedValue.id, {
          filtros: filtrosOficina,
          params: { page: 1, limit: 1000, order: 'ASC', orderBy: 'razonSocial' }
        });
        if (oficinasResponse?.data && oficinasResponse.data.length > 0) {
          setOficinas(oficinasResponse.data);
        } else {
          setOficinas([]);
        }
      } else {
        setOficinas([]);
      }
      // Limpiar oficina seleccionada cuando cambia el AAFF
      setBusqueda({
        ...busqueda,
        [name]: selectedValue?.id,
        oficina_id: undefined,
      });
      return;
    }

    setBusqueda({
      ...busqueda,
      [name]: selectedValue?.id,
    });
  };

  const busquedaInput = (name, valorBusqueda) => {
    if (
      name === "aaff_id" &&
      user.rol !== "AAFF" &&
      (busqueda.aaff_id !== undefined || valorBusqueda)
    ) {
      const filtrosAaff = {
        razonSocial: valorBusqueda,
        excludeChildren: true,
      };
      if (
        user.rol === "TECH_COOR" &&
        busqueda.tech_id
      ) {
        filtrosAaff.tech_id = busqueda.tech_id;
      }
      listAAFFs({
        filtros: filtrosAaff,
        params: {},
      }).then((res) => {
        setAAFF(orderArray(res.data));
      });
    }

    if (
      name === "tech_id" &&
      (busqueda.tech_id !== undefined || valorBusqueda)
    ) {
      const team_id = user.rol === "TECH_COOR" ? user.equipo : null;
      let filtro = {};
      user.rol === "TECH_COOR"
        ? (filtro =
          busqueda.tech_id !== undefined
            ? { id: busqueda.tech_id, team_id }
            : { nombreA: valorBusqueda, team_id })
        : (filtro =
          busqueda.tech_id !== undefined
            ? { id: busqueda.tech_id }
            : { nombreA: valorBusqueda });
      listTecnicos({
        filtros: filtro,
      }).then((res) => {
        setTecnicos(ordenarNombreYApellido(res.data));
      });
    }

    if (
      name === "consul_id" &&
      (busqueda.consul_id !== undefined || valorBusqueda)
    ) {
      listCosultor({
        filtros:
          busqueda.consul_id !== undefined
            ? { id: busqueda.consul_id }
            : {
              nombreA: valorBusqueda,
            },
        params: {},
      }).then((res) => {
        setConsultores(ordenarNombreYApellido(res.data));
      });
    }

    if (
      name === "oficina_id" &&
      user.rol === "AAFF" &&
      user.parent === true &&
      (busqueda.oficina_id !== undefined || valorBusqueda)
    ) {
      getChildrenAaffs(user.id, {
        filtros: {
          razonSocial: valorBusqueda
        },
        params: { page: 1, limit: 1000, order: 'ASC', orderBy: 'razonSocial' }
      }).then((res) => {
        if (res?.data) {
          const oficinasPadre = {
            id: user.id,
            razonSocial: user.razonSocial || user.nombre || "Oficina Principal",
            nif: user.nif
          };

          if (valorBusqueda && user.razonSocial && !user.razonSocial.toLowerCase().includes(valorBusqueda.toLowerCase())) {
            setOficinas(res.data);
          } else {
            setOficinas([oficinasPadre, ...res.data]);
          }
        }
      });
    }

    // Búsqueda de oficinas para otros roles (cuando hay un AAFF seleccionado)
    if (
      name === "oficina_id" &&
      user.rol !== "AAFF" &&
      busqueda.aaff_id &&
      (busqueda.oficina_id !== undefined || valorBusqueda)
    ) {
      const filtrosOficina = { razonSocial: valorBusqueda };
       if (user.rol === "TECH_COOR") {
        // Coordinador: oficinas asignadas a su equipo (subordinados)
        filtrosOficina.team_id = user.equipo;
      } else if (user.rol === "TECH") {
        filtrosOficina.tech_id = user.id;
      }
      getChildrenAaffs(busqueda.aaff_id, {
        filtros: filtrosOficina,
        params: { page: 1, limit: 1000, order: 'ASC', orderBy: 'razonSocial' }
      }).then((res) => {
        if (res?.data) {
          setOficinas(res.data);
        }
      });
    }
  };

  function handleChange(evt) {
    const { value, name, checked } = evt.target;
    const switchNames = ["pendientes", "visitasRecientes", "ocultarImpagados"];
    setBusqueda((prev) => {
      const newBusqueda = { ...prev };
      if (switchNames.includes(name)) {
        if (checked) {
          newBusqueda[name] = true;
        } else {
          delete newBusqueda[name];
        }
      } else {
        if (name === "unRealized") {
          if (value === "") {
            delete newBusqueda[name];
          } else {
            newBusqueda[name] = value === "true";
          }
        } else {
          newBusqueda[name] = value;
        }
      }
      if (name === "servp_id" || name === "grupoServp_ids") {
        const showVencimiento = Number(newBusqueda.servp_id) === 2 || Number(newBusqueda.servp_id) === 4 || Number(newBusqueda.grupoServp_ids) === 2;
        if (!showVencimiento) {
          delete newBusqueda.VencimientoInicio;
          delete newBusqueda.VencimientoFin;
        }
      }

      return newBusqueda;
    });
  }

  // Municipios dependientes de la provincia seleccionada (mismo patrón que en Comunidades)
  useEffect(() => {
    setListadoMunicipios(
      municipiosIniciales(provinces, municipalities, busqueda?.provincia)
    );
  }, [busqueda]);

  const seleccionarMunicipios = (e) => {
    let codProvincia = "";
    let municipios = [];
    provinces.forEach((p) => {
      if (p.name === e.target.value) {
        codProvincia = p.code;
      }
    });
    setBusqueda((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      municipio: "",
    }));
    municipalities.forEach((m) => {
      if (m.provCode === codProvincia) {
        municipios.push({
          ...m,
          name: cambiarFormatoNombre(m.name),
          value: m.name,
        });
      }
    });
    setListadoMunicipios(municipios);
  };

  const getBusqueda = () => {
    for (let key in busqueda) {
      if (
        busqueda[key] === "" ||
        busqueda[key] === null ||
        busqueda[key] === undefined
      ) {
        delete busqueda[key];
      }
    }
    if (busqueda.consul_id == undefined) {
      setSinConsul(true);
    }
    // Agregar timestamp para forzar actualización
    busqueda.searchTimestamp = Date.now();
    onFilter(busqueda);
  };

  const hasValue = (value) => value != null && value !== '' && (!Array.isArray(value) || value.length > 0);

  const getDisabledGroupByService = () => {
    const servicioId = busqueda.servp_id;
    const grupoServicioId = busqueda.grupoServp_ids;
  
    if ([1, 3, 6, 7].includes(Number(servicioId)) || [1].includes(Number(grupoServicioId))) {
      return 'cae';
    }
    
    if ([2, 4].includes(Number(servicioId)) || [2].includes(Number(grupoServicioId))) {
      return 'lopd';
    }
    
    if ([8, 9].includes(Number(servicioId)) || [3].includes(Number(grupoServicioId))) {
      return 'cai';
    }

    return 'none';
  };

  const grupoEnUso = getDisabledGroupByService();

  // Para añadir un grupo nuevo: 1) sumar su entrada aquí, 2) añadir su isGrupoXxxDisabled
  // cruzándolo con los demás, 3) actualizar los disabled existentes para incluir el nuevo.
  const camposPorGrupo = {
    cae: ['estadoCae', 'workersCae', 'fechaVentaInicio', 'fechaVentaFin'],
    lopd: ['estadoLopd', 'workersLopd', 'surveillanceVideo', 'fechaVencimientoInicio', 'fechaVencimientoFin'],
    cai: ['estadoCai'],
  };

  const grupoActivo = (grupo) =>
    camposPorGrupo[grupo].some(c => hasValue(busqueda?.[c])) || grupoEnUso === grupo;

  let isGrupoCaeDisabled = grupoActivo('lopd') || grupoActivo('cai');
  let isGrupoLopdDisabled = grupoActivo('cae') || grupoActivo('cai');
  let isGrupoCaiDisabled = grupoActivo('cae') || grupoActivo('lopd');
  
  const showVencimiento = Number(busqueda.servp_id) === 2 || Number(busqueda.servp_id) === 4 || Number(busqueda.grupoServp_ids) === 2;
  
  busqueda.grupoEnUso =
    grupoActivo('cae') ? 'cae' :
    grupoActivo('lopd') ? 'lopd' :
    grupoActivo('cai') ? 'cai' :
    'none';
  
  const esTecnico = rol === "TECH" || rol === "TECH_COOR";

  return (
    <>
      <div className="buscadorFiltros">
        <Box mx={1} display="flex" flexDirection="column" gap={2}>
          {rol !== "AAFF" && (
            <div className="filtrosContent">
              <label className="titleLabel">{t('filters.filterRoles')}</label>
              {rol !== "AAFF" && (
                <>
                  {user.rol !== "SUPP" && user.rol !== "AAFF" && (
                    <>
                      <FormControl
                        variant="outlined"
                        className="filtros-select"
                      >
                        <SearchProgresState
                          labelId="aaff-label"
                          id="aaff-select"
                          label={t('filters.propertyManager')}
                          name="aaff_id"
                          className="filtros altura"
                          tipo="razonSocial"
                          array={aaff}
                          onOptionSelected={handleAsynchronousChange}
                          busquedaInput={busquedaInput}
                          valueOnLoad={
                            aaff.find((c) => c.id === busqueda.aaff_id) || null
                          }
                        />
                      </FormControl>

                      <FormControl
                        variant="outlined"
                        className="filtros-select"
                      >
                        <SearchProgresState
                          labelId="oficina-label"
                          id="oficina-select"
                          label={t('filters.office')}
                          name="oficina_id"
                          className="filtros altura"
                          tipo="razonSocial"
                          array={oficinas}
                          onOptionSelected={handleAsynchronousChange}
                          busquedaInput={busquedaInput}
                          valueOnLoad={
                            oficinas.find((c) => c.id === busqueda.oficina_id) || null
                          }
                          disabled={!busqueda.aaff_id || oficinas.length === 0}
                        />
                      </FormControl>

                      <TextField
                        id="aaffNif-input"
                        labelId="aaffNif-label"
                        label={t('filters.nifAaff')}
                        name="aaffNif"
                        className="filtros altura"
                        value={busqueda.aaffNif || ""}
                        onChange={handleChange}
                        onKeyPress={(e) =>
                          e.key === "Enter" ? getBusqueda() : ""
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </>
                  )}

                  {(user.rol === "ADMIN") && (
                    <>
                      <FormControl
                        variant="outlined"
                        className="filtros-select"
                      >
                        <InputLabel id="team_id-label">{t('filters.techTeams')}</InputLabel>
                        <Select
                          labelId="team_id-label"
                          id="team_id-select"
                          label={t('filters.techTeams')}
                          name="team_id"
                          className="filtros"
                          value={busqueda.team_id || ""}
                          onChange={handleChange}
                          onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                        >
                          <MenuItem value="" style={{ height: 40 }}></MenuItem>
                          {(Array.isArray(equipos) ? equipos : []).map((e) => {
                            let nombreEquipo = e.nombre ? e.nombre.replace(/_/g, ' ') : '';
                            nombreEquipo = nombreEquipo.replace(/equipo/gi, ' ');
                            return (
                              <MenuItem key={e.id} value={e.id}>
                                {nombreEquipo}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </>
                  )}

                  {(user.rol === "ADMIN" ||
                    user.rol === "CONSUL" ||
                    user.rol === "TECH_COOR") && (
                      <>
                        <FormControl
                          variant="outlined"
                          className="filtros-select"
                        >
                          <SearchProgresState
                            labelId="tecnicos-label"
                            id="tecnicos-select"
                            label={t('filters.technicians')}
                            name="tech_id"
                            className="filtros"
                            tipo="nombre"
                            array={tecnicos}
                            onOptionSelected={handleAsynchronousChange}
                            busquedaInput={busquedaInput}
                            valueOnLoad={tecnicos.find(
                              (c) => c.id === busqueda.tech_id
                            )}
                          />
                        </FormControl>
                        {user.rol !== "TECH_COOR" && (
                          <FormControl
                            variant="outlined"
                            className="filtros-select"
                          >
                            <SearchProgresState
                              labelId="consultores-label"
                              id="consultores-select"
                              label={t('filters.gestDoc')}
                              name="consul_id"
                              className="filtros"
                              tipo="nombre"
                              array={consultores}
                              onOptionSelected={handleAsynchronousChange}
                              busquedaInput={busquedaInput}
                              valueOnLoad={consultores.find(
                                (c) => c.id === busqueda.consul_id
                              )}
                            />
                          </FormControl>
                        )}
                      </>
                    )}
                </>
              )}
            </div>
          )}
          {rol === "AAFF" && user.parent === true && (
            <div className="filtrosContent">
              <label className="titleLabel">{t('filters.filterByOffice')}</label>
              <FormControl variant="outlined" className="filtros-select">
                <SearchProgresState
                  labelId="oficina-label"
                  id="oficina-select"
                  label={t('filters.office')}
                  name="oficina_id"
                  className="filtros altura"
                  tipo="razonSocial"
                  array={oficinas}
                  onOptionSelected={handleAsynchronousChange}
                  busquedaInput={busquedaInput}
                  valueOnLoad={
                    oficinas.find((c) => c.id === busqueda.oficina_id) || null
                  }
                />
              </FormControl>
            </div>
          )}
          <div className="filtros-container">
            <div className="filtrosContent">
              <label className="titleLabel">
                {user.rol === "AAFF" ? <></> : t('filters.salesFilters')}{" "}
              </label>
              <FormControl variant="outlined" className="filtros-select">
                <InputLabel id="ano-label">{t('filters.year')}</InputLabel>
                <Select
                  labelId="ano-label"
                  id="ano-select"
                  label={t('filters.year')}
                  name="ano"
                  className="filtros"
                  value={busqueda.ano || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                >
                  <MenuItem value="" style={{ height: 40 }}></MenuItem>
                  {listAnos?.map((e, i) => (
                    <MenuItem key={i} value={Number(e)}>
                      {e}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {user.rol !== "SUPP" && user.rol !== "AAFF" && (
                <>
                  <TextField
                    type={typeVentaInicio}
                    id="fechaVentaInicio-input"
                    label={t('filters.saleDateFrom')}
                    variant="outlined"
                    name="fechaVentaInicio"
                    className="filtros altura"
                    value={busqueda.fechaVentaInicio || ""}
                    onChange={handleChange}
                    onFocus={handleFocusVentaInicio}
                    onBlur={handleBlurVentaInicio}
                    onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                    inputProps={{ "aria-label": "controlled" }}
                    InputLabelProps={esSafari() ? { shrink: true } : undefined}
                  />
                  <TextField
                    type={typeVentaFin}
                    id="fechaVentaFin-input"
                    label={t('filters.saleDateTo')}
                    variant="outlined"
                    name="fechaVentaFin"
                    className="filtros altura"
                    value={busqueda.fechaVentaFin || ""}
                    onChange={handleChange}
                    onFocus={handleFocusVentaFin}
                    onBlur={handleBlurVentaFin}
                    onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                    inputProps={{ "aria-label": "controlled" }}
                    InputLabelProps={esSafari() ? { shrink: true } : undefined}
                  />
                </>
              )}

              {user.rol !== "SUPP" &&
                user.rol !== "COMM" &&
                user.rol !== "AAFF" && (
                  <>
                    <TextField
                      type={typeCreacionInicio}
                      id="fechaCreacionInicio-input"
                      label={t('filters.realizationDateFrom')}
                      variant="outlined"
                      name="fechaCreacionInicio"
                      className="filtros altura"
                      value={busqueda.fechaCreacionInicio || ""}
                      onChange={handleChange}
                      onFocus={handleFocusCreacionInicio}
                      onBlur={handleBlurCreacionInicio}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                      disabled={isGrupoCaeDisabled && isGrupoCaiDisabled}
                      inputProps={{ "aria-label": "controlled" }}
                      InputLabelProps={esSafari() ? { shrink: true } : undefined}
                    />
                    <TextField
                      type={typeCreacionFin}
                      id="fechaCreacionFin-input"
                      label={t('filters.realizationDateTo')}
                      variant="outlined"
                      name="fechaCreacionFin"
                      className="filtros altura"
                      value={busqueda.fechaCreacionFin || ""}
                      onChange={handleChange}
                      onFocus={handleFocusCreacionFin}
                      onBlur={handleBlurCreacionFin}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                      disabled={isGrupoCaeDisabled && isGrupoCaiDisabled}
                      inputProps={{ "aria-label": "controlled" }}
                      InputLabelProps={esSafari() ? { shrink: true } : undefined}
                    />
                  </>
                )}
              {(rol === "ADMIN" || user.rol === "CONSUL") && (
                <>
                  <FormControl variant="outlined" className="filtros-select">
                    <InputLabel id="estadoCae-label">{t('filters.stateCae')}</InputLabel>
                    <Select
                      labelId="comunidad-label"
                      id="estadoCae-select"
                      label={t('filters.stateCae')}
                      name="estadoCae"
                      className="filtros"
                      value={
                        Array.isArray(busqueda.estadoCae)
                          ? busqueda.estadoCae
                          : []
                      }
                      onChange={handleChange}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                      multiple
                      disabled={isGrupoCaeDisabled}
                    >
                      {estados.length > 0 && estados.map((e) => {
                        return (
                          <MenuItem key={e.id} value={e.id}>
                            {t(`stateNames.${e.nombre}`, e.nombre)}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined" className="filtros-select">
                    <InputLabel id="estadoLopd-label">{t('filters.stateLopd')}</InputLabel>
                    <Select
                      labelId="estadoLopd-label"
                      id="estadoLopd-select"
                      label={t('filters.stateLopd')}
                      name="estadoLopd"
                      className="filtros"
                      value={
                        Array.isArray(busqueda.estadoLopd)
                          ? busqueda.estadoLopd
                          : []
                      }
                      onChange={handleChange}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                      multiple
                      disabled={isGrupoLopdDisabled}
                    >
                      {estados.map((e) => {
                        return (
                          <MenuItem key={e.id} value={e.id}>
                            {t(`stateNames.${e.nombre}`, e.nombre)}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined" className="filtros-select">
                    <InputLabel id="estadoCai-label">{t('filters.stateCai')}</InputLabel>
                    <Select
                      labelId="estadoCai-label"
                      id="estadoCai-select"
                      label={t('filters.stateCai')}
                      name="estadoCai"
                      className="filtros"
                      value={
                        Array.isArray(busqueda.estadoCai)
                          ? busqueda.estadoCai
                          : []
                      }
                      onChange={handleChange}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                      multiple
                      disabled={isGrupoCaiDisabled}
                    >
                      {estados.filter(e => [1, 4, 5].includes(e.id))
                      .map((e) => {
                        return (
                          <MenuItem key={e.id} value={e.id}>
                            {t(`stateNames.${e.nombre}`, e.nombre)}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </>
              )}
              {rol !== "AAFF" && (
                <>
                  <FormControl variant="outlined" className="filtros-select">
                    <InputLabel id="estado-label">{t('filters.state')}</InputLabel>
                    <Select
                      labelId="estado-label"
                      id="estado-select"
                      label={t('filters.state')}
                      name="visitada"
                      className="filtros"
                      value={busqueda?.visitada ?? ""}
                      onChange={handleChange}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                    >
                      <MenuItem value="" style={{ height: 40 }}>
                        {t('filters.all')}
                      </MenuItem>
                      <MenuItem value={false} style={{ height: 40 }}>
                        {t('filters.pending')}
                      </MenuItem>
                      <MenuItem value={true} style={{ height: 40 }}>
                        {t('filters.visited')}
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
                    {["CONSUL", "ADMIN", "TECH", "TECH_COOR"].includes(rol) && (
                      <Box display="flex" alignItems="center">
                        <FormControl variant="outlined" className="filtros-select" sx={{ minWidth: '200px' }}>
                          <InputLabel id="unRealized-label">{t('filters.noVisitReason')}</InputLabel>
                          <Select
                            labelId="unRealized-label"
                            id="unRealized-select"
                            label={t('filters.noVisitReason')}
                            name="unRealized"
                            className="filtros"
                            value={busqueda?.unRealized !== undefined ? String(busqueda.unRealized) : ""}
                            onChange={handleChange}
                            disabled={isGrupoCaeDisabled}
                            onKeyPress={(e) =>
                              e.key === "Enter" ? getBusqueda() : ""
                            }
                          >
                            <MenuItem value="" style={{ height: 40 }}>
                              
                            </MenuItem>
                            <MenuItem value="false" style={{ height: 40 }}>
                              {t('filters.no')}
                            </MenuItem>
                            <MenuItem value="true" style={{ height: 40 }}>
                              {t('filters.yes')}
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <Tooltip
                          title={t('tooltips.unrealizedVisitsInfo')}
                          style={{ fontSize: "16px", marginLeft: "8px" }}
                        >
                          <span>
                            <IoInformationCircleOutline />
                          </span>
                        </Tooltip>
                      </Box>
                    )}
                    {user.rol !== "ADMIN_CAI" && (
                      <>
                        <Box display="flex" alignItems="center">
                          <FormControlLabel
                            sx={{ margin: 0 }}
                            control={
                              <CustomSwitch
                                name="visitasRecientes"
                                checked={busqueda.visitasRecientes}
                                onChange={handleChange}
                                disabled={isGrupoCaeDisabled}
                              />
                            }
                            labelId="estado-label"
                            label={t('filters.hideRecentVisits')}
                          />
                          <Tooltip
                            title={
                              "Muestra el servicio pendiente más antiguo de las comunidades que no se han visitado en la última semana"
                            }
                            style={{ fontSize: "16px" }}
                          >
                            <span>
                              <IoInformationCircleOutline />
                            </span>
                          </Tooltip>
                        </Box>

                        <Box display="flex" alignItems="center">
                          <FormControlLabel
                            sx={{ margin: 0 }}
                            control={
                              <CustomSwitch
                                name="pendientes"
                                checked={busqueda.pendientes}
                                onChange={handleChange}
                                disabled={isGrupoCaeDisabled}
                              />
                            }
                            label={t('filters.showPendingImplementation')}
                          />
                          <Tooltip
                            title={
                              "Muestra todas los servicios de implantación que están pendientes de visitar"
                            }
                            style={{ fontSize: "16px" }}
                          >
                            <span>
                              <IoInformationCircleOutline />
                            </span>
                          </Tooltip>
                        </Box>

                        {/* <Box display="flex" alignItems="center">
                          <FormControlLabel
                            sx={{ margin: 0 }}
                            control={
                              <CustomSwitch
                                name="ocultarImpagados"
                                checked={busqueda.ocultarImpagados || false}
                                onChange={handleChange}
                              />
                            }
                            label={t('filters.hideImpagados', { defaultValue: 'Ocultar impagados' })}
                          />
                          <Tooltip
                            title={"Oculta los servicios cuya factura está impagada (por defecto se muestran todos)"}
                            style={{ fontSize: "16px" }}
                          >
                            <span>
                              <IoInformationCircleOutline />
                            </span>
                          </Tooltip>
                        </Box> */}
                      </>
                    )}
                  </Box>
                  
                </>
              )}
              
            </div>
            <div className="filtrosContent">
              <label className="titleLabel">
                {user.rol === "AAFF" ? <></> : t('filters.communityFilters')}{" "}
              </label>
              <FormControl variant="outlined" className="filtros-select">
                <TextField
                  id="razonSocial-input"
                  label={t('filters.community')}
                  variant="outlined"
                  name="razonSocial"
                  className="filtros altura"
                  value={busqueda.razonSocial || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </FormControl>
              <TextField
                id="nif-input"
                label={t('filters.nifCommunity')}
                variant="outlined"
                name="nif"
                className="filtros altura"
                value={busqueda.nif || ""}
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                inputProps={{ "aria-label": "controlled" }}
              />
              <TextField
                id="codigoPostal-input"
                label={t('filters.postalCode')}
                variant="outlined"
                name="codigoPostal"
                className="filtros altura"
                value={busqueda.codigoPostal || ""}
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                inputProps={{ "aria-label": "controlled" }}
              />
              
              <FormControl variant="outlined" className="filtros-select">
                <InputLabel id="provincia-label">{t('filters.province')}</InputLabel>
                <Select
                  labelId="provincia-label"
                  id="province-select"
                  label={t('filters.province')}
                  name="provincia"
                  className="filtros"
                  value={busqueda.provincia || ""}
                  onChange={seleccionarMunicipios}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                >
                  <MenuItem value="" style={{ height: 40 }}></MenuItem>
                  {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                    return (
                      <MenuItem key={i} value={e.name}>
                        {e.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl variant="outlined" className="filtros-select">
                <InputLabel id="municipio-label">{t('filters.municipalities')}</InputLabel>
                <Select
                  labelId="municipio-label"
                  id="municipio-select"
                  label={t('filters.municipality')}
                  name="municipio"
                  className="filtros"
                  value={busqueda?.municipio || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                >
                  <MenuItem value="" style={{ height: 40 }}></MenuItem>
                  {listadoMunicipios
                    .sort(ordenarProvinciasYMunicipios)
                    ?.map((e, i) => {
                      return (
                        <MenuItem key={i} value={e.name}>
                          {e.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
              {rol !== "ADMIN_CAI" && (
                <FormControl variant="outlined" className="filtros-select">
                  <InputLabel id="servicio-label">{t('filters.service')}</InputLabel>
                  <Select
                    labelId="servicio-label"
                    id="servicio-select"
                    label={t('filters.service')}
                    name="servp_id"
                    className="filtros"
                    value={busqueda.servp_id || ""}
                    onChange={handleChange}
                    onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                    disabled={busqueda.grupoServp_ids}
                  >
                    <MenuItem value="" style={{ height: 40 }}></MenuItem>
                    {servicios?.map((e, i) =>
                      (!esTecnico || user.gruposServicios?.includes(e.group_id)) ? (
                        <MenuItem key={i} value={Number(e.id) || ""}>
                          {e.nombre}
                        </MenuItem>
                      ) : null
                    )}
                  </Select>
                </FormControl>
              )}
              {(rol === "CONSUL" || rol === "VENT" || rol === "ADMIN" || rol !== "ADMIN_CAI") && (
                <>
                  <FormControl variant="outlined" className="filtros-select">
                    <InputLabel id="grupo-servicio-label">{t('filters.serviceGroup')}</InputLabel>
                    <Select
                      labelId="grupo-servicio-label"
                      id="grupo-servicio-select"
                      label={t('filters.serviceGroup')}
                      name="grupoServp_ids"
                      className="filtros"
                      value={busqueda.grupoServp_ids || ""}
                      onChange={handleChange}
                      onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                      disabled={busqueda.servp_id}
                    >
                      <MenuItem value="" style={{ height: 40 }}></MenuItem>
                      {(Array.isArray(grupoServicios) ? grupoServicios : [])
                        .filter((e) => !esTecnico || user.gruposServicios?.includes(e.id))
                        .map((e) => {
                          let nombreGrupo = e.nombre ? e.nombre : '';
                          return (
                            <MenuItem key={e.id} value={e.id}>
                              {nombreGrupo}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>  
                </>
              )}
              {rol !== "AAFF" && rol !== "TECH" && rol !== "TECH_COOR" && rol !== "ADMIN_CAI" && (
                <>
                  <FormControl variant="outlined" className="filtros-select">
                    <InputLabel id="videoVigilancia-label">
                      {t('filters.videoSurveillance')}
                    </InputLabel>
                    <Select
                      labelId="videoVigilancia-label"
                      id="videoVigilancia-select"
                      label={t('filters.videoSurveillance')}
                      name="surveillanceVideo"
                      className="filtros"
                      value={busqueda?.surveillanceVideo ?? ""}
                      onChange={handleChange}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                      disabled={isGrupoLopdDisabled}
                    >
                      <MenuItem value="" style={{ height: 40 }}></MenuItem>
                      <MenuItem value={false}> {t('status.no')} </MenuItem>
                      <MenuItem value={Boolean(true)}> {t('status.yes')} </MenuItem>
                    </Select>
                  </FormControl>
                </>
              )}
              {rol !== "AAFF" && rol !== "ADMIN_CAI" && (
                <>
                  <FormControl variant="outlined" className="filtros-select">
                    <InputLabel id="trabajadores-label">
                      {t('filters.workersCae')}
                    </InputLabel>
                    <Select
                      labelId="trabajadores-label"
                      id="trabajadores-select"
                      label={t('filters.workersCae')}
                      name="workersCae"
                      className="filtros"
                      value={busqueda?.workersCae ?? ""}
                      onChange={handleChange}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                      disabled={isGrupoCaeDisabled}
                    >
                      <MenuItem value="" style={{ height: 40 }}></MenuItem>
                      <MenuItem value={Boolean(false)}> {t('status.no')} </MenuItem>
                      <MenuItem value={Boolean(true)}> {t('status.yes')} </MenuItem>
                    </Select>
                  </FormControl>
                </>
              )}
              {(rol === "CONSUL" || rol === "VENT" || rol === "ADMIN") && (
                <>
                  <FormControl variant="outlined" className="filtros-select">
                    <InputLabel id="trabajadoresLopd-label">
                      {t('filters.workersLopd')}
                    </InputLabel>
                    <Select
                      labelId="trabajadoresLopd-label"
                      id="trabajadoresLopd-select"
                      label={t('filters.workersLopd')}
                      name="workersLopd"
                      className="filtros"
                      value={busqueda?.workersLopd ?? ""}
                      onChange={handleChange}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                      disabled={isGrupoLopdDisabled}
                    >
                      <MenuItem value="" style={{ height: 40 }}></MenuItem>
                      <MenuItem value={Boolean(false)}> {t('status.no')} </MenuItem>
                      <MenuItem value={Boolean(true)}> {t('status.yes')} </MenuItem>
                    </Select>
                  </FormControl>
                </>
              )}
              {showVencimiento &&
                <>
                  <TextField
                      type={typeVencimientoInicio}
                      id="fechaVencimientoInicio-input"
                      label={t('filters.expirationDateFrom')}
                      variant="outlined"
                      name="fechaVencimientoInicio"
                      className="filtros altura"
                      value={busqueda.fechaVencimientoInicio || ""}
                      onChange={handleChange}
                      onFocus={handleFocusVencimientoInicio}
                      onBlur={handleBlurVencimientoInicio}
                      onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                      inputProps={{ "aria-label": "controlled" }}
                      InputLabelProps={esSafari() ? { shrink: true } : undefined}
                      disabled={isGrupoLopdDisabled}
                  />
                  <TextField
                      type={typeVencimientoFin}
                      id="fechaVencimientoFin-input"
                      label={t('filters.expirationDateTo')}
                      variant="outlined"
                      name="fechaVencimientoFin"
                      className="filtros altura"
                      value={busqueda.fechaVencimientoFin || ""}
                      onChange={handleChange}
                      onFocus={handleFocusVencimientoFin}
                      onBlur={handleBlurVencimientoFin}
                      onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                      inputProps={{ "aria-label": "controlled" }}
                      InputLabelProps={esSafari() ? { shrink: true } : undefined}
                      disabled={isGrupoLopdDisabled}
                  />
                </>
              }
            </div>
          </div>
        </Box>

        <div>
          <Button className="btn-buscador" onClick={clearAllFilters}>
            <ImCross />
          </Button>
        </div>
        <div>
          <Button className="btn-buscador" onClick={() => getBusqueda()}>
            <BsSearch />
          </Button>
        </div>
      </div>

      <style jsx="true">
        {`
          .btn-buscador {
            padding: 5px 10px;
            color: #ffffff;
            background-color: #92004d;
            border-radius: 4px;
            font-weight: bold;
            width: -moz-fit-content;
            width: fit-content;
            align-self: flex-end;
            border: none;
            min-width: 40px;
            height: 40px;
            margin: 5px 10px 5px;
          }
          .btn-buscador:hover {
            color: black;
            background-color: #dee2e6;
          }
        `}
      </style>
    </>
  );
};

export default withRouter(FiltrosVentas);